import React from 'react';
import { useSelector } from 'react-redux';

import { selectWindxIdSubdivisaoEspacial } from 'redux/reducers/windxControlPanelReducer';

import Conjuntos from './Conjuntos';
import Entidades from './Entidades';
import Usinas from './Usinas';

import './index.scss';

interface SeletorEntidadesSheetProps {
  open: boolean;
  dismiss: () => void;
  // Se `true`, "nenhuma marcada" equivale a "todas selecionadas" (o backend
  // omite `id_entidades` e devolve o conjunto completo). Vale apenas para a
  // tela Comparativo SM.
  permiteSelecaoVazia?: boolean;
}

/**
 * Seletor de entidades do Windx no mobile.
 *
 * Espelha o switch de `Windx/SeletorEntidades` — a escolha de qual seletor
 * abrir e a MESMA do desktop, so a casca muda (BottomSheet no lugar de Modal):
 *   - subdivisao 1 (subsistemas) e demais/legado -> `Entidades`
 *   - subdivisao 3 (conjuntos) -> `Conjuntos`
 *   - subdivisao 4 (usinas) -> `Usinas`
 *
 * Diferenca de organizacao em relacao ao desktop: la o caminho legado mora
 * dentro de `SeletorEntidades/index.tsx` e subsistemas tem componente proprio;
 * aqui os dois vivem em `Entidades/` porque compartilham fonte de dados
 * (`entidades/list`) e regras — muda so o modo de selecao.
 */
export default function SeletorEntidadesSheet({
  open,
  dismiss,
  permiteSelecaoVazia = false,
}: SeletorEntidadesSheetProps) {
  const subdivisao = useSelector(selectWindxIdSubdivisaoEspacial);

  if (subdivisao === 3) {
    return <Conjuntos open={open} dismiss={dismiss} />;
  }

  if (subdivisao === 4) {
    return <Usinas open={open} dismiss={dismiss} permiteSelecaoVazia={permiteSelecaoVazia} />;
  }

  return (
    <Entidades
      open={open}
      dismiss={dismiss}
      subdivisao={subdivisao}
      permiteSelecaoVazia={permiteSelecaoVazia}
    />
  );
}
